module.exports = __webpack_public_path__ + "img/newspapers_button_main_up.bda0c2be.png";